<template>
  <form ref="form" v-bind="$attrs">
    <slot></slot>
    
  </form>
</template>

<script>
export default {
  props: {
    valid: {
      type: Boolean
    }
  },
  data() {
    return {
      validBag: {}
    }
  },
  mounted() {
    let inputs = this.$children;

    inputs.forEach(input => {
      this.watchInput(input);
      this.$set(this.validBag, input._uid, input.isValid);
    })
    
    this.checkValidity();
  },
  methods: {
    watchInput(input) {
      input.$watch('isValid', v => {
        this.$set(this.validBag, input._uid, v);
      });
      input.$watch('value', () => {
        this.checkValidity();
      })
    },
    checkValidity() {
      const isValid = Object.values(this.validBag).filter(d => d === false).length === 0;
      this.$emit('update:valid', isValid);
    }
  }
}
</script>

<style scoped>
</style>
